import React from 'react';
import { Helmet } from 'react-helmet-async';
import styles from '@/styles/pages/HelpPage.module.css';

const HelpPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Help & FAQ - Swarmind</title>
        <meta
          name="description"
          content="Learn more about Swarmind, what it does, and how to get started."
        />
        <meta property="og:title" content="Help & FAQ - Swarmind" />
        <meta
          property="og:description"
          content="Frequently asked questions about Swarmind and how to use the platform."
        />
        <meta property="og:url" content="https://swarmind.ai/help" />
        <meta property="og:type" content="website" />
        <meta property="twitter:title" content="Help & FAQ - Swarmind" />
        <meta
          property="twitter:description"
          content="Frequently asked questions about Swarmind and how to use the platform."
        />
        <meta property="twitter:url" content="https://swarmind.ai/help" />
      </Helmet>

      <div className={styles.page}>
        <header className={styles.header}>
          <h1 className={styles.title}>Help & FAQ</h1>
          <p className={styles.subtitle}>
            Learn what Swarmind is, how it works, and how to get started.
          </p>
        </header>

        <section className={styles.faqSection} aria-label="Swarmind frequently asked questions">
          <article className={styles.faqItem}>
            <h2 className={styles.faqQuestion}>What is Swarmind?</h2>
            <p className={styles.faqAnswer}>
              Swarmind is a decentralised platform which provides access to custom large language models
              hosted on private machines.
            </p>
          </article>

          <article className={styles.faqItem}>
            <h2 className={styles.faqQuestion}>What services does Swarmind provide?</h2>
            <p className={styles.faqAnswer}>
              First and foremost, we provide access to various LLMs, including text models, image generation,
              text-to-speech and image recognition. Secondly, we provide authors of models with a way to
              monetize their work via our decentralised payment system. Same goes for hardware suppliers.
            </p>
          </article>

          <article className={styles.faqItem}>
            <h2 className={styles.faqQuestion}>How does our payment system work?</h2>
            <p className={styles.faqAnswer}>
              We're a decentralised platform, so we incorporate web3 to manage payments: in exchange for USDT
              you get access to any custom model that suits your needs. Of course, we also provide you with
              free tokens so you can just play around before moving forward.
            </p>
          </article>

          <article className={styles.faqItem}>
            <h2 className={styles.faqQuestion}>How to use the service?</h2>
            <p className={styles.faqAnswer}>
              Just pick your desired model in the chat window and chat with it.
            </p>
          </article>

          <article className={styles.faqItem}>
            <h2 className={styles.faqQuestion}>How to connect my GPU?</h2>
            <p className={styles.faqAnswer}>
              Currently we connect hardware to cluster manually. Just contact us via Telegram and we'll set you
              up!
            </p>
          </article>

          <article className={styles.faqItem}>
            <h2 className={styles.faqQuestion}>How to apply my LLM?</h2>
            <p className={styles.faqAnswer}>
              For a detailed walkthrough and help, contact us via Telegram!
            </p>
          </article>
        </section>
      </div>
    </>
  );
};

HelpPage.displayName = 'HelpPage';

export default HelpPage;


